export default __webpack_public_path__ + "static/blue-1c4132381a36ea376b5b0a970180fa00.png";